module.exports = __webpack_public_path__ + "static/media/innovation.b100563a.png";